import ApiService from 'src/shared/utils/base-api/api-service';
import {
  ICampaignCustomersList,
  ICampaignHistoryList,
  ICampaignList,
  ICampaignPayload,
  ICampaignsData,
} from './dto/campaign-list';
import {IPaginateProducts} from 'src/shared/common-dtos/get-all-paginate';

class CampaignService extends ApiService {
  constructor() {
    super({baseURL: '/AdminNewsLetter'});
  }

  campaignList(payload: IPaginateProducts): Promise<ICampaignList> {
    return this.get('/GetAllCampaigns', {params: {...payload}});
  }

  getCampaign(campaignId: string): Promise<ICampaignPayload> {
    return this.get('/GetCampaignById', {params: {campaignId}});
  }

  campaignHistory(id: string): Promise<ICampaignHistoryList> {
    return this.get('/GetCampaignHistory', {params: {campaignId: id}});
  }

  campaignCustomers(id: string): Promise<ICampaignCustomersList> {
    return this.get('/GetCampaignCustomersSubscriptions', {
      params: {campaignId: id},
    });
  }

  addCampaign(payload: ICampaignPayload): Promise<ICampaignsData> {
    return this.post('/CreateCampaign', payload);
  }

  updateCampaign(payload: ICampaignPayload): Promise<ICampaignsData> {
    return this.post('/EditCampaign', payload);
  }

  sendMassEmail(payload: ICampaignPayload) {
    return this.post('/SendMassEmail', {}, {params: {...payload}});
  }

  sendTestEmail(payload: ICampaignPayload) {
    return this.post('/SendTestEmail', {}, {params: {...payload}});
  }

  deleteCampaign(id: string) {
    return this.delete('/DeleteCampaign', {params: {id}});
  }
}

export const campaignService = new CampaignService();
